export const ROUTES = {
    ROOT: '/',
    CHAT: '/:tabId/chat',
    TEMPLATES: '/:tabId/templates',
    TEMPLATE: '/:tabId/template',
    DOCUMENT: '/:tabId/document',
    DOCUMENTS: '/:tabId/documents',
    PROJECT: '/:tabId/project',
    SETTING: '/settings',
    PHOTOGRAPHER: '/:tabId/photographer',
    SIGN_IN: '/sign-in',
    VERIFY_MAGIC_LINK: '/verify-magic-link',
    BRAND_VOICE: '/:tabId/brand-voice',
    INFOBASE: '/:tabId/infobase',
};
